<template>
  <div>
    <el-card class="">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('dictManage.queryCondition') }}</span>
      </div>
      <div class="filter-container">
        <el-form :inline="true" :model="dictManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-select v-model="dictManageInfo.conditions.specId" :placeholder="$t('dictManage.selectType')"
              style="width:100%">
              <el-option v-for="item in dictManageInfo.dictSpecs" :key="item.specId" :label="item.specName"
                :value="item.specId" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="dictManageInfo.conditions.name" :placeholder="$t('dictManage.inputName')" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="dictManageInfo.conditions.statusCd" :placeholder="$t('dictManage.inputValue')" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryDictMethod">
              <i class="el-icon-search"></i>
              {{ $t('dictManage.query') }}
            </el-button>
            <el-button @click="_resetDictMethod">
              <i class="el-icon-refresh"></i>
              {{ $t('dictManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('dictManage.dictInfo') }}</span>
        <el-button type="primary" size="small" class="float-right" @click="_openAddDictModal">
          <i class="el-icon-plus"></i>
          {{ $t('dictManage.add') }}
        </el-button>
      </div>
      <el-table :data="dictManageInfo.dicts" border style="width:100%">
        <el-table-column prop="specName" :label="$t('dictManage.dictType')" align="center" />
        <el-table-column prop="name" :label="$t('dictManage.name')" align="center" />
        <el-table-column prop="statusCd" :label="$t('dictManage.value')" align="center" />
        <el-table-column prop="description" :label="$t('dictManage.description')" align="center" />
        <el-table-column :label="$t('dictManage.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditDictModel(scope.row)">
              {{ $t('dictManage.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteDictModel(scope.row)">
              {{ $t('dictManage.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination-container" background @current-change="handleCurrentChange"
        :current-page="dictManageInfo.conditions.page" :page-size="dictManageInfo.conditions.row"
        layout="total, prev, pager, next, jumper" :total="dictManageInfo.total" />
    </el-card>

    <add-dict ref="addDict" @refresh="_listDicts" />
    <edit-dict ref="editDict" @refresh="_listDicts" />
    <delete-dict ref="deleteDict" @refresh="_listDicts" />
  </div>
</template>

<script>
import { listDict, listDictSpec } from '@/api/dev/dictApi'
import AddDict from '@/components/dev/addDict/addDict'
import EditDict from '@/components/dev/editDict/editDict'
import DeleteDict from '@/components/dev/deleteDict/deleteDict'

export default {
  name: 'DictManage',
  components: {
    AddDict,
    EditDict,
    DeleteDict
  },
  data() {
    return {
      dictManageInfo: {
        dicts: [],
        dictSpecs: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          specId: '',
          name: '',
          statusCd: ''
        }
      }
    }
  },
  created() {
    this._listDictSpecs()
    this._listDicts()
  },
  methods: {
    async _listDicts() {
      try {
        const params = {
          ...this.dictManageInfo.conditions,
          name: this.dictManageInfo.conditions.name.trim(),
          statusCd: this.dictManageInfo.conditions.statusCd.trim()
        }
        const res = await listDict(params)
        this.dictManageInfo.dicts = res.data
        this.dictManageInfo.total = res.total
      } catch (error) {
        console.error('获取字典列表失败:', error)
      }
    },
    async _listDictSpecs() {
      try {
        const res = await listDictSpec({ page: 1, row: 1000 })
        this.dictManageInfo.dictSpecs = res.data
      } catch (error) {
        console.error('获取字典类型失败:', error)
      }
    },
    _openAddDictModal() {
      this.$refs.addDict.open()
    },
    _openEditDictModel(row) {
      this.$refs.editDict.open(row)
    },
    _openDeleteDictModel(row) {
      this.$refs.deleteDict.open(row)
    },
    _queryDictMethod() {
      this.dictManageInfo.conditions.page = 1
      this._listDicts()
    },
    _resetDictMethod() {
      this.dictManageInfo.conditions = {
        page: 1,
        row: 10,
        specId: '',
        name: '',
        statusCd: ''
      }
      this._listDicts()
    },
    handleCurrentChange(val) {
      this.dictManageInfo.conditions.page = val
      this._listDicts()
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.float-right {
  float: right;
}
</style>